<template>
    <div>
        <div class="payment__footer" :class="$vuetify.breakpoint.mdAndDown ? 'px-4' : ''">
            <div class="payment__footer--content">
                <div class="payment__footer--actions d-flex justify-end align-center" style="height: 100%;">
                    <v-btn
                        class="text-none mr-8 payment__footer--actions__back-button"
                        text
                        large
                        rounded
                        color="primary"
                        @click="goBack()"
                    >
                        <v-icon>fxt-chevron-left</v-icon>
                        <div class="font-weight-bold px-2">Tilbake</div>
                    </v-btn>
                    <v-btn
                        class="text-none payment__footer--actions__pay-button"
                        rounded
                        large
                        :disabled="disabled"
                        elevation="0"
                        @click="startPaymentProcess()"
                    >
                        <div class="font-weight-bold pl-8 pr-1">Betal</div>
                        <v-icon color="white" class="pr-8">fxt-check</v-icon>
                    </v-btn>
                </div>
            </div>
        </div>
        <div>
            <common-dialog
                v-if="showError"
                :show="showError"
                title="Noe gikk galt"
                icon="fxt-warning"
                :buttonTextConfirm="buttonOverride.length ? buttonOverride : 'Ok'"
                buttonColorConfirm="error"
                buttonTextColorConfirm="white"
                @closeDialog="showError = false"
                @confirmAction="buttonOverride.length ? '' : showError = false"
                layout="portal"
                >
                <p>{{errorMessage}}</p>
            </common-dialog>
        </div>
        <div>
            <v-overlay :value="loading" color="white" absolute>
            <v-progress-circular
                color="var(--v-primary-base)"
                indeterminate
                size="64"
            ></v-progress-circular>
            </v-overlay>
        </div>
    </div>
</template>
  
<script>
import PaymentSvc from '../../../../../services/payment-svc';
import ProfileSvc from '../../../../../services/profile-svc';
import { CommonDialog } from "../../../../Common/CommonComponents";
let profileSvc = null;
let paymentSvc = null;
let wp = null
export default {
    props: {
        user: {
            required: true
        }
    },
    components: {CommonDialog},
    data: () => ({
        appointment: null,
        sessionCancelled: false,
        paymentComplete: false,
        loading: false,
        session: null,
        showError: false,
        errorTitle: '',
        buttonOverride: '',
        createdFairpay: null
    }),
    methods: {
        goBack() {
            if (this.$route.params.order) {
                if (this.$route.path.includes('ikke-mott')) {
                    this.$router.push({name: 'Ikke møtt detaljer', params: {id: this.$route.params.id, siteId: this.$route.params.siteId, order: this.$route.params.order}})
                } else {
                    this.$router.push('/bestillinger')
                }
            } else {
                this.$router.push({name: 'Ikke møtt'})
            }
        },
        goToNoShows() {
            this.showError = false;
            this.$router.push({name: 'Ikke møtt'})
        },
        goToPaymentConfirmation() {
            this.$router.push({name: this.$route.path.includes('sen-kansellering') ? 'Betalingsbekreftelse for kansellering' : 'Betalingsbekreftelse', params: {id: this.appointment.base64AppointmentId, siteId: this.appointment.siteId, order: this.appointment}})
        },
        async createPaymentSession() {
            this.sessionCancelled = false
            const isLateCancellation = this.$route.path.includes('sen-kansellering')

            if (isLateCancellation) {
                this.createdFairpay = this.$store.getters['fairpay/getCreatedFairpay']
                !this.appointment ? this.appointment = this.$route.params.order : null
            } else {
                let noShows = this.$store.getters['fairpay/getFairPayAppointments']
                this.appointment = noShows.find(x => x.base64AppointmentId === this.$route.params.id)
            }
            
            const fairPayId = isLateCancellation ? (this.createdFairpay ? this.createdFairpay.fairPayIdBase64 : '') : this.appointment.base64FairPayId;
            const timebokBesokId = isLateCancellation ? this.createdFairpay ? this.createdFairpay.timebokBesokIdBase64 : '' : this.appointment.base64AppointmentId
            
            const sessionResponse = await this.$store.dispatch('payment/createSession',
                {
                    fairPayId: fairPayId,
                    session: {
                        fixitSiteId: this.appointment.fixitSiteId,
                        customer: {onlineSluttKundeId: this.user.onlineSluttKundeId},
                        expiresAt: this.$moment(new Date).add(30, 'm').toDate().toISOString(),
                        paymentType: this.$store.getters['payment/getSelectedPaymentMethod'],
                        paymentTokenId: this.$store.getters['payment/getPaymentTokenId'] || '',
                        url: {
                            returnUrl: process.env.VUE_APP_CHECKOUT_WINDOW_URL + '?parent_url=' + process.env.VUE_APP_FIXIT_PROFILE_URL,
                            passCallbackUrl: `${process.env.VUE_APP_SALONG_DATA_API}/FairPay/pay-online-fee-callback?fairPayId=${fairPayId}`
                        },
                        order: {
                            currency: 'NOK',
                            merchantReference: this.appointment.base64AppointmentId,
                            items: [
                                {
                                    amount: this.appointment.actualFee * 100,
                                    description: 'Ikke møtt',
                                    id: timebokBesokId,
                                    quantity: 1,
                                    name: 'Ikke møtt'
                                }
                            ],
                        },
                    }
                }
            )

            if (sessionResponse.success && !sessionResponse.alreadyPaid) {
                this.session = this.$store.getters['payment/getSession']
            }

            return sessionResponse
        },
        async startPaymentProcess() {
            this.errorMessage = ''
            this.showError = false

            this.loading = true
            wp = window.open(
                process.env.VUE_APP_CHECKOUT_WINDOW_URL +
                    '?parent_url=' +
                    process.env.VUE_APP_FIXIT_PROFILE_URL,
                '_blank',
                'toolbar=yes,scrollbars=yes,top=0,left=0,width=400,height=600'
            );
            const sessionResponse = await this.createPaymentSession();
            // It's already paid, so we need to redirect back to the appointment list page the user came from
            if (sessionResponse.alreadyPaid) {
                if (wp) {
                    this.closeWindow();
                }
                this.$router.push({name: this.$route.path.includes('sen-kansellering') ? 'Mine besøk og bestillinger' : 'Ikke møtt'})
            }
            else if (this.session) {
                wp.location.href = process.env.VUE_APP_CHECKOUT_WINDOW_URL + '/?session_id=' + this.session.guid + '&parent_url=' + process.env.VUE_APP_FIXIT_PROFILE_URL
            } else {
                this.errorMessage = 'Feil ved opprettelse av betalingssesjon. Prøv igjen, om problemet vedvarer ta kontakt med kundesenter på kundesenter@fixit.no.'
                this.showError = true
            }

            window.addEventListener('message', this.handlePaymentPostMessage)
            /**
             * Handle when a user manually closes the payment window
             */
            const timer = setInterval(async () => {
                if (wp && wp.closed) {
                    if (!this.sessionCancelled && !this.paymentComplete && this.session) {
                        await this.$store.dispatch('payment/cancelSession', this.session.guid)
                        .then((success) => {
                            if (success) {
                                this.sessionCancelled = false; //reset flag
                            }
                        });
                    }
                    if (!this.paymentComplete) {
                        this.errorMessage = 'Betalingsvinduet ble lukket før betaling ble gjennomført.'
                        this.showError = true
                    }
                    clearInterval(timer);
                    window.removeEventListener('message', this.handlePaymentPostMessage);
                    this.closeWindow();
                }
            }, 1000);
        },
        async handlePaymentPostMessage(event) {
            if (!(event.origin === process.env.VUE_APP_CHECKOUT_WINDOW_URL || event.origin === process.env.VUE_APP_FIXIT_PROFILE_URL)) {
                return; 
            }
            switch (event.data.paymentStatus) {
                case 'SessionPaymentAuthorized':
                    this.paymentComplete = true
                    this.closeWindow();
                    this.goToPaymentConfirmation()
                    await this.$store.dispatch('fairpay/getFairPayAppointmentDetails')
                    
                    break;
                case 'SessionCancel':
                    if (this.$route.path.includes('sen-kansellering') && this.session && !this.paymentcomplete) {
                        this.closeWindow();
                    }
                    this.sessionCancelled = true
                    return {};
                case 'SessionPaymentError':
                case '':
                    if (this.$route.path.includes('sen-kansellering')) { 
                        this.errorMessage = 'Det oppstod en feil. Prøv igjen, om problemet vedvarer ta kontakt med kundesenter på kundesenter@fixit.no.'
                        this.showError = true
                    }
                    this.paymentComplete = true
                    this.closeWindow();
                    return {};
                default:
                    return {}
            }
        },
        closeWindow() {
            window.removeEventListener('message', this.handlePaymentPostMessage);
            if (wp) {
                wp.focus();
                wp.close();
                if (wp.opener) {
                    /**
                     * Try closing once a second until it's closed. On mobile: A popup
                     * might interfer with the initial close attempt, so we need to try again if
                     * it didn't succeed.
                     */
                    const timer = setInterval(async () => {
                        wp.focus();
                        wp.close();
                    if (wp && !wp.opener) {
                        clearInterval(timer);
                    }
                    }, 1000);
                }
            }
            this.loading = false
        }
    },
    computed: {
        disabled() {
            return this.$store.getters['payment/getSelectedPaymentMethod'] === null
        }
    },
    async mounted() {
        profileSvc = await ProfileSvc(this.$axios);
		paymentSvc = await PaymentSvc(this.$axios);
        if (!this.$route.params.order) {
            this.appointment = await profileSvc.GetAppointmentById(
                process.env.VUE_APP_FIXIT_NO_BOOKING_URL,
                this.$route.params.siteId,
                this.$route.params.id,
                1
            );
        }
        const token = await profileSvc.GetPaymentToken()
        if (token.pspTokenId) {
            this.$store.commit('payment/setPaymentTokenId', token.pspTokenId)
        }
	},
    beforeDestroy() {
		paymentSvc = null
        profileSvc = null
	}
}
</script>

<style scoped lang="scss">
    .payment {
        padding-top: 20px;
        margin-bottom: 100px;
        width: 100vw;
        &__container {
            &--content {
                max-width: 770px;
                margin: 0 auto;
            }
        }
        &__footer {
            position: fixed;
            background: rgba(223, 242, 244, 1);
            width: 100%;
            height: 78px;
            bottom: 0px;
            &--content {
                height: 100%;
                max-width: 770px;
                margin: 0 auto;
            }
            &--actions {
                &__back-button {
                    font-size: 16px;
                    font-weight: 700;
                    line-height: 24px;
                }
                &__pay-button {
                    background: rgba(234, 65, 42, 1) !important;
                    color: white;
                    font-size: 16px;
                    font-weight: 700;
                    line-height: 24px;
                }
            }
        }
    }
</style>
  